const AUTH_ME_SNAPSHOT_KEY = 'ff_auth_me_snapshot';

export function saveAuthMeSnapshot(me) {
  if (typeof window === 'undefined' || !me || typeof me !== 'object') return;
  try {
    localStorage.setItem(AUTH_ME_SNAPSHOT_KEY, JSON.stringify(me));
  } catch {
    // ignore quota / private mode
  }
}

export function loadAuthMeSnapshot() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(AUTH_ME_SNAPSHOT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAuthMeSnapshot() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(AUTH_ME_SNAPSHOT_KEY);
  } catch {
    // ignore
  }
}
